import React, { useState, lazy } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Check, ShieldCheck, Package, X } from 'lucide-react';
const PRODUCT_IMAGE = 'https://cdn.magicpatterns.com/uploads/ofPY8ZEeCjA6SqsAuD1cbc/3.webp';
export function PricingSection() {
  const [showModal, setShowModal] = useState(false);
  const handleBuyClick = () => {
    setShowModal(true);
  };
  return <section id="pricing" className="py-28 md:py-32 bg-slate-50 text-slate-900 relative overflow-hidden" data-id="element-195">
      {/* Modal */}
      <AnimatePresence data-id="element-196">
        {showModal && <div className="fixed inset-0 z-50 flex items-center justify-center px-4" data-id="element-197">
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} className="absolute inset-0 bg-black/40 backdrop-blur-sm" onClick={() => setShowModal(false)} data-id="element-198" />
            <motion.div initial={{
          opacity: 0,
          scale: 0.9,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.9,
          y: 20
        }} transition={{
          type: 'spring',
          duration: 0.5
        }} className="relative bg-white rounded-2xl shadow-2xl p-8 md:p-10 max-w-md w-full text-center z-10" data-id="element-199">
              <button onClick={() => setShowModal(false)} className="absolute top-4 right-4 text-slate-400 hover:text-slate-600 transition-colors" data-id="element-200">
                <X className="w-5 h-5" data-id="element-201" />
              </button>
              <div className="w-16 h-16 rounded-full bg-brand-50 border border-brand-200 flex items-center justify-center mx-auto mb-6" data-id="element-202">
                <Package className="w-8 h-8 text-brand-500" data-id="element-203" />
              </div>
              <h3 className="text-2xl font-serif font-bold text-slate-900 mb-3" data-id="element-204">
                Produkt bald verfügbar
              </h3>
              <p className="text-slate-500 mb-8" data-id="element-205">
                Wir arbeiten mit Hochdruck daran, UroNacht für Sie
                bereitzustellen. Bitte schauen Sie bald wieder vorbei!
              </p>
              <button onClick={() => setShowModal(false)} className="w-full py-3 px-6 rounded-lg bg-slate-900 text-white font-bold hover:bg-slate-800 transition-colors duration-300" data-id="element-206">
                Verstanden
              </button>
            </motion.div>
          </div>}
      </AnimatePresence>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-207">
        <div className="text-center mb-20" data-id="element-208">
          <motion.span initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-brand-500 font-bold tracking-[0.2em] text-sm uppercase mb-4 block" data-id="element-209"></motion.span>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-slate-900 mb-6" data-id="element-210">
            Wählen Sie Ihr Paket
          </motion.h2>
          <p className="text-slate-500 max-w-2xl mx-auto text-lg" data-id="element-211">
            Kostenloser Versand ab 3 Flaschen. 60-Tage-Geld-zurück-Garantie auf
            alle Bestellungen.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-center max-w-6xl mx-auto" data-id="element-212">
          {/* Starter */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-white p-8 rounded-2xl border border-slate-200 flex flex-col h-full hover:border-brand-200 hover:shadow-md transition-all duration-300" data-id="element-213">
            <div className="flex items-center gap-3 mb-2" data-id="element-214">
              <Package className="w-6 h-6 text-slate-400" data-id="element-215" />
              <h3 className="text-2xl font-bold text-slate-900" data-id="element-216">Starter</h3>
            </div>
            <div className="text-base text-slate-500 mb-6" data-id="element-217">1 Monatsvorrat</div>

            <div className="flex justify-center mb-6" data-id="element-218">
              <img src={PRODUCT_IMAGE} alt="1x UroNacht" className="w-36 h-auto opacity-90" width={144} height={216} loading="lazy" decoding="async" data-id="element-219" />
            </div>

            <div className="mb-4" data-id="element-220">
              <span className="text-5xl font-serif font-bold text-slate-900" data-id="element-221">
                €39,90
              </span>
            </div>
            <div className="text-base text-slate-500 mb-8" data-id="element-222">
              €39,90 pro Flasche
            </div>
            <button id="buyButton" onClick={handleBuyClick} className="w-full py-4 px-6 rounded-lg border-2 border-slate-900 text-slate-900 font-bold hover:bg-slate-50 transition-colors duration-300 mb-8 tracking-wide" data-id="element-223">
              Jetzt bestellen
            </button>
            <ul className="space-y-4 text-base text-slate-600" data-id="element-224">
              <li className="flex items-center gap-3" data-id="element-225">
                <div className="p-1 rounded-full bg-brand-50" data-id="element-226">
                  <Check className="w-3 h-3 text-brand-500" data-id="element-227" />
                </div>
                1 Flasche UroNacht
              </li>
              <li className="flex items-center gap-3" data-id="element-228">
                <div className="p-1 rounded-full bg-brand-50" data-id="element-229">
                  <Check className="w-3 h-3 text-brand-500" data-id="element-230" />
                </div>
                60-Tage-Garantie
              </li>
            </ul>
          </motion.div>

          {/* Popular */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-white p-10 rounded-2xl border-2 border-brand-500 relative transform md:-translate-y-6 shadow-xl shadow-brand-900/5 flex flex-col h-full z-10" data-id="element-231">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-brand-500 text-white text-sm font-bold uppercase py-2 px-6 rounded-full tracking-widest shadow-lg shadow-brand-500/20 whitespace-nowrap" data-id="element-232">
              Beliebteste Wahl
            </div>
            <div className="flex items-center gap-3 mb-2 mt-2" data-id="element-233">
              <Package className="w-6 h-6 text-brand-500" data-id="element-234" />
              <h3 className="text-2xl font-bold text-slate-900" data-id="element-235">Bestseller</h3>
            </div>
            <div className="text-base text-slate-500 mb-6" data-id="element-236">3 Monatsvorrat</div>

            <div className="flex justify-center items-end gap-1 mb-6" data-id="element-237">
              <img src={PRODUCT_IMAGE} alt="UroNacht" className="w-24 h-auto opacity-80 -rotate-6" width={96} height={144} loading="lazy" decoding="async" data-id="element-238" />
              <img src={PRODUCT_IMAGE} alt="UroNacht" className="w-32 h-auto relative z-10 drop-shadow-md" width={128} height={192} loading="lazy" decoding="async" data-id="element-239" />
              <img src={PRODUCT_IMAGE} alt="UroNacht" className="w-24 h-auto opacity-80 rotate-6" width={96} height={144} loading="lazy" decoding="async" data-id="element-240" />
            </div>

            <div className="mb-2" data-id="element-241">
              <span className="text-6xl font-serif font-bold text-slate-900" data-id="element-242">
                €109,90
              </span>
            </div>
            <div className="text-lg text-brand-500 font-medium mb-2" data-id="element-243">
              €36,60 pro Flasche
            </div>
            <div className="text-sm text-brand-600 font-bold mb-8 bg-brand-50 inline-block px-3 py-1.5 rounded-full border border-brand-100" data-id="element-244">
              Sie sparen €29,80
            </div>
            <button onClick={handleBuyClick} className="relative overflow-hidden w-full py-5 px-6 rounded-lg bg-slate-900 text-white font-bold hover:bg-slate-800 transition-colors duration-300 mb-8 shadow-lg text-lg tracking-wide group" data-id="element-245">
              <span className="relative z-10" data-id="element-246">Jetzt bestellen</span>
            </button>
            <ul className="space-y-4 text-base text-slate-600" data-id="element-247">
              <li className="flex items-center gap-3" data-id="element-248">
                <div className="p-1 rounded-full bg-brand-100" data-id="element-249">
                  <Check className="w-4 h-4 text-brand-500" data-id="element-250" />
                </div>
                3 Flaschen UroNacht
              </li>
              <li className="flex items-center gap-3" data-id="element-251">
                <div className="p-1 rounded-full bg-brand-100" data-id="element-252">
                  <Check className="w-4 h-4 text-brand-500" data-id="element-253" />
                </div>
                Kostenloser Versand
              </li>
              <li className="flex items-center gap-3" data-id="element-254">
                <div className="p-1 rounded-full bg-brand-100" data-id="element-255">
                  <Check className="w-4 h-4 text-brand-500" data-id="element-256" />
                </div>
                60-Tage-Garantie
              </li>
            </ul>
          </motion.div>

          {/* Best Value */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-white p-8 rounded-2xl border border-slate-200 flex flex-col h-full hover:border-brand-200 hover:shadow-md transition-all duration-300" data-id="element-257">
            <div className="flex items-center gap-3 mb-2" data-id="element-258">
              <Package className="w-6 h-6 text-slate-400" data-id="element-259" />
              <h3 className="text-2xl font-bold text-slate-900" data-id="element-260">
                Beste Ersparnis
              </h3>
            </div>
            <div className="text-base text-slate-500 mb-6" data-id="element-261">6 Monatsvorrat</div>

            <div className="flex justify-center items-end gap-0.5 mb-6" data-id="element-262">
              <img src={PRODUCT_IMAGE} alt="UroNacht" className="w-14 h-auto opacity-60 -rotate-12" width={56} height={84} loading="lazy" decoding="async" data-id="element-263" />
              <img src={PRODUCT_IMAGE} alt="UroNacht" className="w-16 h-auto opacity-70 -rotate-6" width={64} height={96} loading="lazy" decoding="async" data-id="element-264" />
              <img src={PRODUCT_IMAGE} alt="UroNacht" className="w-20 h-auto relative z-10" width={80} height={120} loading="lazy" decoding="async" data-id="element-265" />
              <img src={PRODUCT_IMAGE} alt="UroNacht" className="w-16 h-auto opacity-70 rotate-6" width={64} height={96} loading="lazy" decoding="async" data-id="element-266" />
              <img src={PRODUCT_IMAGE} alt="UroNacht" className="w-14 h-auto opacity-60 rotate-12" width={56} height={84} loading="lazy" decoding="async" data-id="element-267" />
              <img src={PRODUCT_IMAGE} alt="UroNacht" className="w-12 h-auto opacity-50 rotate-[18deg]" width={48} height={72} loading="lazy" decoding="async" data-id="element-268" />
            </div>

            <div className="mb-2" data-id="element-269">
              <span className="text-5xl font-serif font-bold text-slate-900" data-id="element-270">
                €189,90
              </span>
            </div>
            <div className="text-base text-brand-500 font-medium mb-2" data-id="element-271">
              €31,65 pro Flasche
            </div>
            <div className="text-xs text-brand-600 font-bold mb-8 bg-brand-50 inline-block px-3 py-1.5 rounded-full border border-brand-100" data-id="element-272">
              Sie sparen €99,50
            </div>
            <button onClick={handleBuyClick} className="w-full py-4 px-6 rounded-lg border-2 border-slate-900 text-slate-900 font-bold hover:bg-slate-50 transition-colors duration-300 mb-8 tracking-wide" data-id="element-273">
              Jetzt bestellen
            </button>
            <ul className="space-y-4 text-base text-slate-600" data-id="element-274">
              <li className="flex items-center gap-3" data-id="element-275">
                <div className="p-1 rounded-full bg-brand-50" data-id="element-276">
                  <Check className="w-3 h-3 text-brand-500" data-id="element-277" />
                </div>
                6 Flaschen UroNacht
              </li>
              <li className="flex items-center gap-3" data-id="element-278">
                <div className="p-1 rounded-full bg-brand-50" data-id="element-279">
                  <Check className="w-3 h-3 text-brand-500" data-id="element-280" />
                </div>
                Kostenloser Versand
              </li>
              <li className="flex items-center gap-3" data-id="element-281">
                <div className="p-1 rounded-full bg-brand-50" data-id="element-282">
                  <Check className="w-3 h-3 text-brand-500" data-id="element-283" />
                </div>
                60-Tage-Garantie
              </li>
            </ul>
          </motion.div>
        </div>

        <div className="mt-16 text-center text-base text-slate-500 flex flex-wrap justify-center gap-8" data-id="element-284">
          <span className="flex items-center gap-2" data-id="element-285">
            <ShieldCheck className="w-5 h-5 text-brand-500" data-id="element-286" />{' '}
            60-Tage-Geld-zurück-Garantie
          </span>
          <span className="flex items-center gap-2" data-id="element-287">
            <ShieldCheck className="w-5 h-5 text-brand-500" data-id="element-288" /> Sichere Bezahlung
          </span>
          <span className="flex items-center gap-2" data-id="element-289">
            <ShieldCheck className="w-5 h-5 text-brand-500" data-id="element-290" /> Kostenloser
            Versand ab 3 Flaschen
          </span>
        </div>
      </div>
    </section>;
}